var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "preview-wrap", class: { compact: _vm.compact } },
    [
      _c("div", { staticClass: "ticket" }, [
        _c("div", { staticClass: "title-area" }, [
          _vm.config.showTitle
            ? _c("div", { staticClass: "big-title" }, [
                _vm._v(_vm._s(_vm.config.titleText)),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.config.showOrderSequence
            ? _c("div", { staticClass: "seq-line" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.data.sequence) +
                    " " +
                    _vm._s(
                      _vm.config.showPlatformName ? _vm.config.platformName : ""
                    ) +
                    "\n      "
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.config.showStoreName
            ? _c("div", { staticClass: "store-line" }, [
                _vm._v("* " + _vm._s(_vm.config.storeName) + " *"),
              ])
            : _vm._e(),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "divider" }),
        _vm._v(" "),
        _c("div", { staticClass: "info-area" }, [
          _vm.config.showDeliveryTime
            ? _c("div", { staticClass: "row" }, [
                _c("span", [_vm._v("送达时间：")]),
                _vm._v(" "),
                _c("span", { staticClass: "bold" }, [
                  _vm._v(_vm._s(_vm.data.deliveryTime)),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.config.showOrderTime
            ? _c("div", { staticClass: "row" }, [
                _c("span", [_vm._v("下单时间：")]),
                _vm._v(" "),
                _c("span", [_vm._v(_vm._s(_vm.data.orderTime))]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.config.showOrderNumber
            ? _c("div", { staticClass: "row" }, [
                _c("span", [_vm._v("订单编号：")]),
                _vm._v(" "),
                _c("span", [_vm._v(_vm._s(_vm.data.orderNumber))]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.config.showRemark
            ? _c("div", { staticClass: "remark" }, [
                _c("span", [_vm._v("备注：")]),
                _vm._v(_vm._s(_vm.data.remark) + "\n      "),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.config.showPhone
            ? _c("div", { staticClass: "small" }, [
                _vm._v(
                  "联系方式：" +
                    _vm._s(
                      _vm.config.phoneMask ? _vm.maskedPhone : _vm.data.phone
                    )
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.config.showAddress
            ? _c("div", { staticClass: "small" }, [
                _vm._v(
                  "地址：" +
                    _vm._s(
                      _vm.config.addressMask
                        ? _vm.maskedAddress
                        : _vm.data.address
                    )
                ),
              ])
            : _vm._e(),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "divider" }),
        _vm._v(" "),
        _vm.config.showGoodsList
          ? _c(
              "div",
              { staticClass: "goods-area" },
              [
                _c("div", { staticClass: "row header" }, [
                  _c("span", { staticClass: "name-col" }, [_vm._v("商品")]),
                  _vm._v(" "),
                  _vm.config.showQuantity
                    ? _c("span", { staticClass: "count-col" }, [_vm._v("数量")])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.config.showPrice
                    ? _c("span", { staticClass: "price-col" }, [_vm._v("小计")])
                    : _vm._e(),
                ]),
                _vm._v(" "),
                _vm._l(_vm.data.goods, function (item, idx) {
                  return _c("div", { key: idx, staticClass: "goods-item" }, [
                    _c("div", { staticClass: "name" }, [
                      _vm._v(_vm._s(item.name)),
                    ]),
                    _vm._v(" "),
                    _vm.config.showGoodsBarcode
                      ? _c("div", { staticClass: "barcode" }, [
                          _vm._v(_vm._s(_vm.getBarcode(item, idx))),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", { staticClass: "row" }, [
                      _c("span", { staticClass: "name-col" }),
                      _vm._v(" "),
                      _vm.config.showQuantity
                        ? _c("span", { staticClass: "count-col" }, [
                            _vm._v("x" + _vm._s(item.quantity)),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.config.showPrice
                        ? _c("span", { staticClass: "price-col" }, [
                            _vm._v("￥" + _vm._s(_vm.formatPrice(item.price))),
                          ])
                        : _vm._e(),
                    ]),
                  ])
                }),
              ],
              2
            )
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "divider" }),
        _vm._v(" "),
        _c("div", { staticClass: "footer-area" }, [
          _vm.config.showTotalPrice
            ? _c("div", { staticClass: "row total" }, [
                _c("span", [
                  _vm._v(_vm._s(_vm.config.totalPriceLabel || "合计")),
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "bold" }, [
                  _vm._v("￥" + _vm._s(_vm.formatPrice(_vm.totalPrice))),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.config.showOrderSequence
            ? _c("div", { staticClass: "seq-bottom" }, [
                _vm._v(
                  "\n        **** " +
                    _vm._s(_vm.data.sequence) +
                    " " +
                    _vm._s(
                      _vm.config.showPlatformName ? _vm.config.platformName : ""
                    ) +
                    " ****\n      "
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.config.showTips
            ? _c("div", { staticClass: "tips" }, [
                _vm._v(_vm._s(_vm.config.tipsText)),
              ])
            : _vm._e(),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }